import React, { Component } from 'react';
import { compose } from 'recompose';
import { withCalendar, withAppointmentDraggable } from './CalendarContext';
import CardAppointment from './CardAppointment';

export default compose(
  withAppointmentDraggable,
  withCalendar
)(CardAppointment);
